import React from 'react';
import { Container, Heading } from '@hover/blueprint';

const HowHoverWorksHeader: React.FC = () => (
  <Container centerContent maxW="2xl">
    <Heading
      style={{ marginBottom: 24 }}
      textAlign="center"
      size={{ base: 500, tablet: 600, desktop: 700 }}
      isLight
    >
      How does HOVER work?
    </Heading>
    <Heading
      style={{ marginBottom: 80 }}
      textAlign="center"
      size={{ base: 200, desktop: 500 }}
      isDisplay
    >
      HOVER generates the most accurate measurements (and a whole lot more) from
      a few photos of your home.
    </Heading>
  </Container>
);

export default HowHoverWorksHeader;
